const snackbar = {
  open: false,
  message: "",
};

export default snackbar;



// WEBPACK FOOTER //
// ./app/data/snackbar.js